import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EContractType } from '../../../../api-models/common/json_query';

const ID = 'contract' as const;

const CONTRACT_LABELS: Record<EContractType, string> = {
  [EContractType.DirectRent]: 'Прямая аренда',
  [EContractType.SubRent]: 'Субаренда',
  [EContractType.PermTransfer]: 'Переуступка',
  [EContractType.ObjSale]: 'Продажа',
};

export const contractTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('contract')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: CONTRACT_LABELS[t as EContractType],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('contract')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0 ? setTerms('contract')(jsonQuery)(next) : resetTerms(['contract'])(jsonQuery);
  },
};
